import {dateFormat} from "../../../services/misc.functions";
import {bulletinProvider} from "../../../features/bulletin/bulletin.service";

import {useAvailableLongtermHippodromes, useDailyRaces} from "../../../features/bulletin/bulletin.store";
import React, {useEffect, useRef} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {LongtermBetslip, useLongtermBetslip} from "../../../features/betslip/longterm.service";
import {LongtermBetslipSidebar, LongtermMobileBetslip} from "./longterm.betslip";
import {isMobile} from "../../../App";
import lockIcon from "../../../assets/feather/lock.svg";
import paths from "../../../paths";
import check from "../../../assets/feather/check.svg";

function getLongtermEventSlug(event: any) {
    return `${(event?.hippodrome_key || '').toString().toLowerCase()}${event?._id}`;
}

function LongtermHeader({hippodrome}: any) {
    return (
        <div className={"d-flex justify-content-between align-items-center flex-wrap p-3"} style={{
            backgroundColor:'var(--primary-color)',
        }}>
            <div className="d-flex flex-column">
                {!isMobile && <h5 className="card-title text-white mb-0">{hippodrome.hippodrome}</h5>}
                <div className="fw-light text-white">{hippodrome.description}</div>
            </div>
            <div className="d-flex flex-column">
                <span className="fs-6 text-white">Kapanış: {dateFormat(hippodrome._date)}</span>
            </div>
        </div>
    );
}

function LongtermBody({hippodrome}: any) {
    return (
        <div className="row p-3 pt-0 border">
            {Object.entries(hippodrome.event_odds).map(([no, odd]: any) => {
                const isAddedHorse = LongtermBetslip.isAdded(hippodrome, odd);
                return (
                    <div className={"col-6 col-md-3"} key={`longterm-horse-${hippodrome._id}-${no}`}>
                        <div className={"longterm-odd-item" + (isAddedHorse !== false ? " selected" : "")}
                             onClick={() => LongtermBetslip.toggle(hippodrome, odd)}>
                            <span className="fw-bold fs-6">{odd.description}</span>
                            <div className="longterm-odd-pill">
                                {odd && odd.status === "o" && (Number(odd.win_odds ?? 0) > 0) ? Number(odd.win_odds).toFixed(2) :
                                    <img width={18} src={lockIcon} alt="kapalı"/>}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    );
}

export function LongTermBettingRoot() {
    const navigator = useNavigate();
    // Bülten güncellemesinde yeniden çizim artık anlık görüntüden geliyor.
    const dailyRaces = useDailyRaces();
    const availableLongtermHippodromes = useAvailableLongtermHippodromes();

    useEffect(() => {
        bulletinProvider.refreshAvailableLongtermHippodromes();
    }, []);

    useEffect(() => {
        // Bkz. betting.tsx'teki aynı koruma: bülten gelmeden "-" yer tutucusuna atlamayalım.
        if (dailyRaces.length === 0) {
            return;
        }
        if (availableLongtermHippodromes.length > 0) {
            navigator(`${paths.bettingLongterm.url}/${getLongtermEventSlug(availableLongtermHippodromes[0])}`, {replace: true});
        } else {
            navigator(`${paths.bettingLongterm.url}/-`, {replace: true});
        }
    }, [availableLongtermHippodromes.length, dailyRaces.length]);

    return (<></>)
}

export function LongTermBetting() {
    const params: any = useParams();
    const navigate = useNavigate();
    const availableLongtermHippodromes = useAvailableLongtermHippodromes();
    const longtermSelection = useLongtermBetslip();
    const redirectTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        bulletinProvider.refreshAvailableLongtermHippodromes();
    }, []);

    const selectedHippodrome = availableLongtermHippodromes.find(
        (event: any) => getLongtermEventSlug(event) === params.hippodrome?.toLowerCase()
    );

    useEffect(() => {
        if (!isMobile || selectedHippodrome || availableLongtermHippodromes.length === 0) {
            return;
        }
        redirectTimer.current = setTimeout(() => {
            navigate(`${paths.bettingLongterm.url}/${getLongtermEventSlug(availableLongtermHippodromes[0])}`, {replace: true});
        }, 3000);
        return () => {
            if (redirectTimer.current) {
                clearTimeout(redirectTimer.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedHippodrome?._id, params.hippodrome, availableLongtermHippodromes.length]);

    if (availableLongtermHippodromes.length === 0) {
        return (
            <div className={"col-12"} style={{minHeight: "75vh"}}>
                <div className={"page-widget"}>
                    <div className="hint-text text-center p-3">
                        <p className={"fs-6 mb-0"}>Uzun Vadeli bahis türünde açık hipodrom bulunmamaktadır.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={"container betting-container pb-5"}>
            {isMobile && <div className="mobile-filter-wrapper">
                <div className={"betting-select w-100 d-flex align-items-center justify-content-center"}
                     onClick={() => {
                         LongtermBetslip.clear();
                         navigate(`${paths.betting.url}`);
                     }}
                     style={{backgroundColor: '#4B6361'}}>
                    Müşterek
                </div>
                <div onClick={() => {
                    LongtermBetslip.clear();
                    navigate(`${paths.bettingFob.url}`);
                }} className={"betting-select w-100 d-flex align-items-center justify-content-center"}
                     style={{backgroundColor: '#4B6361'}}>
                    Sabit İhtimalli
                </div>
                <div className={"betting-select w-100 d-flex align-items-center justify-content-center"}>
                    Uzun Vadeli <div className={"selected-betting-page"}><img width={14} src={check}/></div>
                </div>
            </div>}

            {isMobile && <div style={{backgroundColor: "#1F3735"}}>
                <div className={"container"}>
                    <div className={"fob-hippodrome-wrapper"}>
                        {availableLongtermHippodromes.map((event: any, keyEvent: number) => {
                            return <div key={keyEvent}
                                        className={`fob-hippodrome-item text-truncate ${selectedHippodrome?._id === event._id ? 'selected' : ''}`}
                                        onClick={() => {
                                            navigate(`${paths.bettingLongterm.url}/${getLongtermEventSlug(event)}`);
                                        }}>
                                {(event.hippodrome || '').replace(/\s*Hipodromu\s*$/i, '')}
                            </div>
                        })}
                    </div>
                </div>
            </div>}

            {isMobile ?
                <>
                    {selectedHippodrome && <div className={"page-widget"}>
                        <LongtermHeader hippodrome={selectedHippodrome}/>
                        <LongtermBody hippodrome={selectedHippodrome}/>
                    </div>}
                </>
                :
                <>
                    {availableLongtermHippodromes.map((hippodrome: any, index: number) => (
                        <div className={"page-widget"} key={`longterm-hippodrome-${hippodrome._id || index}`}>
                            <LongtermHeader hippodrome={hippodrome}/>
                            <LongtermBody hippodrome={hippodrome}/>
                        </div>
                    ))}
                </>
            }

            {!isMobile && <LongtermBetslipSidebar/>}
            {isMobile && <LongtermMobileBetslip/>}
        </div>
    );
}
